import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { FilesDropzone } from 'components';
import { makeStyles } from '@mui/styles';
import { enqueueSnackbar } from 'actions';

import ModalDialog from '../../../../components/ModalDialog/ModalDialog.js';
import { UploadTracker } from '../../actions/TrackerActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const TrackerImportModal = (props) => {
	const { onClose, open, ...rest } = props;
	const classes = useStyles();
	const dispatch = useDispatch();

	const _onConfirmClick = file => {
		if (file[0].size > 10000000) {
			dispatch(
				enqueueSnackbar({
					message: `File ${file[0].name} not valid. Please check file size.`,
					options: { variant: 'warning' }
				})
			);
		}
		dispatch(UploadTracker(file[0]));
	};

	return (
		<ModalDialog
			onClose={onClose}
			title="Import Tracker"
			open={open}
			maxWidth="lg"
			hasConfirm={false}
		>
			<FilesDropzone multiple={false} acceptedTypes=".xlsx" upload={_onConfirmClick} />
		</ModalDialog>
	);
};

TrackerImportModal.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired
};

export default TrackerImportModal;
